import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { DataGridFlexSales, useDataGridFlexSales } from '../DataGridFlexSales';

import { synchroDataSelector, synchroLoadingSelector } from '../../state';

import handlerFactory, { SynchroDataGridContext, SynchroLogItem } from './handlerFactory';

const DataGridConfig = () => {
  const { handler } = useDataGridFlexSales<SynchroLogItem, SynchroDataGridContext>();

  const { t } = useTranslation();

  const title = t('synchro4me.title');

  const data = useSelector(synchroDataSelector);
  const loading = useSelector(synchroLoadingSelector);

  const gridContext = useMemo(
    () => ({
      ...handler.context,
      t,
    }),
    [t]
  );

  handler.setData(data);
  handler.setContext(gridContext);
  handler.setTitle(title);
  handler.setLoading(loading);

  return null;
};

const SynchroDataGrid = () => (
  <DataGridFlexSales handlerFactory={handlerFactory}>
    <DataGridConfig />
  </DataGridFlexSales>
);

export default SynchroDataGrid;
